var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "offcanvasElementRef",
      staticClass: "offcanvas offcanvas-end",
      attrs: {
        id: "userProfileOffcanvas",
        tabindex: "-1",
        "aria-labelledby": "userProfileOffcanvasLabel",
      },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-body d-flex flex-column justify-content-between",
        },
        [
          _c(
            "div",
            { staticClass: "flex-fill" },
            [
              _setup.formId
                ? _c(_setup.Form, {
                    attrs: { "form-id": _setup.formId, "hide-help-text": true },
                  })
                : _c("div", { staticClass: "py-5 text-center text-muted" }, [
                    _c("div", {
                      staticClass: "spinner-border text-secondary mb-2",
                      attrs: { role: "status" },
                    }),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _setup.formId
            ? _c(
                "footer",
                { staticClass: "text-center pt-3 border-top mt-auto bg-body" },
                [
                  _c(_setup.FormSaveBtn, {
                    staticClass: "w-100 py-2 btn btn-primary",
                    attrs: {
                      "button-text": "Save Changes",
                      "cancel-on-save": true,
                      "form-id": _setup.formId,
                      form: _setup.formId,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "offcanvas-header border-bottom" }, [
      _c(
        "h5",
        {
          staticClass: "offcanvas-title fw-bold text-body",
          attrs: { id: "userProfileOffcanvasLabel" },
        },
        [_vm._v("\n            User Profile\n        ")]
      ),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "offcanvas",
          "aria-label": "Close",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }